/** @jsxImportSource @emotion/react */
import { MenuItemType } from "constants/menu-list";
import { providerGames, ProviderItemType } from "constants/provider-game";
import { onCheckLoginGameLocal } from "helpers/handleLoginGame";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { filter } from "lodash";
import { useNavigate } from "react-router-dom";
import { selectCategoryDetails } from "store/game";

import { DropdownMenuStyle } from "./index.style";

type Props = {
  categoryCode: string;
  visible: boolean;
  menuItem: MenuItemType;
};

function DropdownMenu({ categoryCode, visible, menuItem }: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const dataProviderStore = useAppSelector(selectCategoryDetails);

  const dataGame = filter(
    providerGames[categoryCode],
    (item: ProviderItemType) => {
      return dataProviderStore.some(
        (i) =>
          (i.provider_code === item.provider_code &&
            i.game_type_code?.includes(item.type)) ||
          item.isLocal,
      );
    },
  );
  if (!Array.isArray(dataGame)) return null;
  return (
    <div css={DropdownMenuStyle.index(visible)}>
      <div>
        {dataGame.map((item, index) => {
          if (!item.provider_code) return null;
          return (
            <div
              onClick={() => {
                if (menuItem.isSubGame) {
                  navigate(`${menuItem.path}/${item.provider_code}`);
                  return;
                }
                onCheckLoginGameLocal(
                  dataProviderStore,
                  item,
                  categoryCode,
                  dispatch,
                  navigate,
                );
              }}
              css={DropdownMenuStyle.itemMenu}
              key={item.provider_code + index}
            >
              <img src={item.icon} alt="" />
              <span>{item.provider_name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DropdownMenu;
